export default __webpack_public_path__ + "static/media/maintenance-box.bf631925.png";